module.exports = __webpack_public_path__ + "img/mozambique.3a028fbe.svg";